import { render, staticRenderFns } from "./ForumJoinRequests.vue?vue&type=template&id=456360e2&scoped=true&"
import script from "./ForumJoinRequests.vue?vue&type=script&lang=js&"
export * from "./ForumJoinRequests.vue?vue&type=script&lang=js&"
import style0 from "./ForumJoinRequests.vue?vue&type=style&index=0&id=456360e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456360e2",
  null
  
)

export default component.exports